import { IReportTypeResponse } from '~/types/response/reportType';
import axiosBase from '~/utils/axios';

export default class ReportTypeService {
  private static route: string = '/reportTypes';

  public static getAll(): Promise<IReportTypeResponse[]> {
    return axiosBase.get(this.route).then(({ data }) => data);
  }
}
